import { forEach, throttle } from 'lodash';
import Mq from 'shared/mq';
// import Dropdown from 'shared/dropdown';

export default class FlexibleNav {
  constructor(root) {
    this.root = root;
    this.list = this.root.querySelector('.u-nav-local__list');
    this.elements = this.root.querySelectorAll('.u-nav-local__item');

    // this.more = new Dropdown(this.root.querySelector('.u-nav-local__more'));
    this.more = this.root.querySelector('.u-nav-local__more');
    this.moreUl = this.more.querySelector('.u-dropdown ul');

    this.onResize();
    this.bind();

    window.setTimeout(() => {
      this.onResize();
    }, 200);
  }

  bind() {
    this.onResize = throttle(this.onResize.bind(this), 300);
    window.addEventListener('resize', this.onResize);
  }

  destroy() {
    // this.more.destroy();
    window.removeEventListener('resize', this.onResize);
  }

  update() {
    this.moreUl.innerHTML = '';
    let totalVisible = 0;

    forEach(this.elements, el => {
      this.updateSingle(el) && totalVisible++;
    });

    if (totalVisible >= this.elements.length) {
      console.info('hide', totalVisible);
      this.more.style.display = 'none';
    } else {
      console.info('show', totalVisible);
      this.more.style.display = 'block';
    }
  }

  updateSingle(el) {
    const visible = this.isElementVisible(el);
    const clone = el.cloneNode(true);

    el.classList[visible ? 'add' : 'remove']('is-visible');

    if (!visible) {
      this.moreUl.appendChild(clone);
    }

    return visible;
  }

  onResize() {
    this.listWidth = this.list.clientWidth;
    this.update();
  }

  isElementVisible(el) {
    const left = el.offsetLeft;
    const width = el.clientWidth;
    const treshold = 5;

    return (left + width) <= (this.listWidth + treshold) && Mq.isMoreThan('xxsmall');
  }
}
